import { useLocation } from "@tanstack/react-router"

export function useObjectTypeAndIdFromUrl(): {
  objectTypeId: number | undefined
  objectId: number | undefined
} {
  const location = useLocation()
  const path = location.pathname

  const patterns: Array<{ regex: RegExp; objectTypeId: number }> = [
    { regex: /^\/app\/contacts\/(\d+)/, objectTypeId: 1 },
    { regex: /^\/app\/contracts\/contracts\/(\d+)/, objectTypeId: 4 },
    { regex: /^\/app\/art\/activities\/(\d+)/, objectTypeId: 2 },
    { regex: /^\/app\/art\/productions\/(\d+)/, objectTypeId: 5 },
  ]

  for (const { regex, objectTypeId } of patterns) {
    const match = path.match(regex)
    if (match && match[1]) {
      return { objectTypeId, objectId: Number(match[1]) }
    }
  }
  return { objectTypeId: undefined, objectId: undefined }
}
